import React, { useState } from "react";
import api from "../lib/api";
import { toast } from "sonner";
import { Search, Loader2, Landmark } from "lucide-react";

export default function RegistryLookup({ value, onFill }) {
  const [busy, setBusy] = useState(false);
  const [info, setInfo] = useState(null);

  const run = async () => {
    const q = (value || "").trim();
    if (!q) { toast.error("Inserisci prima Partita IVA o Codice Fiscale"); return; }
    setBusy(true); setInfo(null);
    try {
      const { data } = await api.get("/registry/lookup", { params: { q } });
      onFill(data.fields);
      setInfo(data);
      toast.success(`Dati recuperati da ${data.source === "openapi" ? "Registro Imprese (OpenAPI.it)" : "VIES"}`);
    } catch (err) {
      const d = err?.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Ricerca non riuscita");
    } finally { setBusy(false); }
  };

  return (
    <div className="md:col-span-2 bg-blue-50 border border-blue-200 rounded-lg p-3" data-testid="registry-lookup">
      <div className="flex flex-wrap items-center gap-3">
        <div className="flex items-center gap-2 text-sm text-blue-900 flex-1 min-w-[200px]">
          <Landmark size={16} /> <span>Compila in automatico dal Registro Imprese / VIES usando la P.IVA o il CF inseriti</span>
        </div>
        <button type="button" onClick={run} disabled={busy} data-testid="registry-lookup-btn"
          className="inline-flex items-center gap-2 bg-blue-700 hover:bg-blue-800 text-white px-3 py-2 rounded-lg text-sm font-medium disabled:opacity-60">
          {busy ? <Loader2 size={14} className="animate-spin" /> : <Search size={14} />} Recupera dati
        </button>
      </div>
      {info && (
        <div className="mt-2 text-xs text-blue-900" data-testid="registry-lookup-info">
          Fonte: <b>{info.source === "openapi" ? "OpenAPI.it – Registro Imprese" : "VIES (Commissione Europea)"}</b>
          {info.vies_valid === true && " · P.IVA valida"}{info.vies_valid === false && " · P.IVA non valida in VIES"}
          {info.stato_attivita && ` · Stato: ${info.stato_attivita}`}
          {info.warning && <div className="text-amber-800 mt-1">{info.warning}</div>}
        </div>
      )}
    </div>
  );
}
